// action types
import ApiService from "../api.service";
import {SET_ERROR} from "./auth.module";

export const DASHBOARD_SALES = "import-sales/list";
export const DASHBOARD_HISTORY_BY_USER = "history/customer";

const state = {
};

const getters = {

};

const actions = {
    [DASHBOARD_SALES](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${DASHBOARD_SALES}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },
    [DASHBOARD_HISTORY_BY_USER](context, payload) {
        return new Promise(resolve => {
            ApiService.query(`/${DASHBOARD_HISTORY_BY_USER}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(( {response} ) => {
                    resolve(response);
                    context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                });
        });
    },

};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
